module.exports = __webpack_public_path__ + "img/supplierEntryGuidelines_03.1f2f4237.png";